/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */


import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName.js";
let LayoutComponentClient = () => import(/* webpackChunkName: "ClientsPortalModule" */  "@/core/recoveryCoachingApp/components/Layouts/LayoutComponentClient.vue");
let PortalEntryPage = () => import(/* webpackChunkName: "ClientsPortalModule" */  "@/core/recoveryCoachingApp/PortalEntryPage.vue");
let EmptyRouterView = () => import(/* webpackChunkName: "ClientsPortalModule" */ '@/core/components/EmptyRouterView.vue')
let ClientPortalMain = () => import(/* webpackChunkName: "ClientsPortalModule" */ '@/core/recoveryCoachingApp/client/portal/ClientPortalMain')
let ClientJournalPageForClient = () => import(/* webpackChunkName: "ClientsPortalModule" */ '@/core/recoveryCoachingApp/client/portal/ClientJournalPageForClient')
let ClientPortalGenogramMain = () => import(/* webpackChunkName: "ClientsPortalModule" */ '@/core/recoveryCoachingApp/client/portal/ClientPortalGenogramMain')
let ClientPortalTimelineMain = () => import(/* webpackChunkName: "ClientsPortalModule" */ '@/core/recoveryCoachingApp/client/portal/ClientPortalTimelineMain')


export default [

	{
		path: '/portalentry',
		name: 'PortalEntryRoute',
		component: PortalEntryPage,
	},

	{
		path: '/portal',
		name: 'ClientMain',
		redirect: redirectByName('ClientPortalMain'),
		component: LayoutComponentClient,
		children: [
			{
				path: 'main',
				name: 'ClientPortalMain',
				component: EmptyRouterView,
				redirect: redirectByName('ClientPortalMainTabs', {activeTab: "first-tab"}),
				props: mergeProps,
				children: [
					{
						path: ':activeTab',
						name: 'ClientPortalMainTabs',
						component: ClientPortalMain,
						props: mergeProps,
					},

				]
			},


			{
				// path: '*',
				path: ':catchAll(.*)*',
				redirect: '/portal'
			},

		]
	},


	{
		path: '',
		name: 'PortalMainRoute',
		redirect: redirectByName('CoachMain'),
	}





	// {
	// 	path: '',
	// 	name: 'PortalMainRoute',
	// 	component: PortalMainPage,
	// 	props: mergeProps,
	// 	children: [
	// 		{
	// 			path: ":ownerId",
	// 			name: "PortalMainRouteWithOwnerId",
	// 			component: EmptyRouterView,
	// 			children: [
	// 				{
	// 					path: 'main',
	// 					name: 'ClientPortalMain',
	// 					component: EmptyRouterView,
	// 					redirect: redirectByName('ClientPortalMainTabs', {activeTab: "first-tab"}),
	// 					props: mergeProps,
	// 					children: [
	// 						{
	// 							path: ':activeTab',
	// 							name: 'ClientPortalMainTabs',
	// 							component: ClientPortalMain,
	// 							props: mergeProps,
	// 						},
	//
	// 					]
	// 				},
	//
	// 				{
	// 					path: 'coach',
	// 					name: 'CoachPortalMain',
	// 					component: EmptyRouterView,
	// 					redirect: redirectByName('CoachPortalMainTabs', {activeTab: "first-tab"}),
	// 					props: mergeProps,
	// 					children: [
	// 					]
	// 				},
	//
	// 				{
	// 					path: 'admin',
	// 					name: 'AdminPortalMain',
	// 					component: EmptyRouterView,
	// 					redirect: redirectByName('AdminPortalMainTabs', {activeTab: "first-tab"}),
	// 					props: mergeProps,
	// 					children: [
	// 					]
	// 				},
	// 			]
	// 		}
	// 	]
	//
	// },




]


